import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { CiMail } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import { BiGlobe } from "react-icons/bi";
import { MdOutlineBloodtype } from "react-icons/md";
import { PiPersonArmsSpreadLight } from "react-icons/pi";
import { LuUsersRound } from "react-icons/lu";
import Stepper from "../Utility/PatientStepper";
import PatientTabs from "../Utility/PatientTabs";

function PatientDetails({ show, onClose }) {
  const patientstyles = `
     .iconStyle {
  background-color: #f5f5f5;
  border-radius: 50%;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-right: 12px;
}

.labelStyle {
  font-size: 0.75rem;
  color: gray;
  margin-bottom: 2px;
}

.valueStyle {
  font-size: 0.89rem;
  font-weight: 500;
}

    `;
  return (
    <>
      <style>{patientstyles}</style>
      <Offcanvas
        show={show}
        onHide={onClose}
        placement="end"
        style={{
          width: "67%",
          margin: ".5rem .5rem",
          borderRadius: "0.5rem 0rem 0px .5rem",
          overflow: "hidden",
        }}
      >
        {/* Left Green Strip */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "6px",
            backgroundColor: "#2abd0d",
            borderRadius: "0.5rem 0 0 0.5rem",
            zIndex: 1,
          }}
        />

        <Offcanvas.Header
          closeButton
          style={{
            borderBottom: "1px solid #dddddd",
          }}
        >
          <Offcanvas.Title>Patient Overview</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body style={{ zIndex: 2, padding: "0px 1rem 1rem 1.5rem" }}>
          <div style={{ display: "flex", height: "100%" }}>
            <div
              style={{
                borderRight: "1px solid #dddddd",
                maxWidth: "16rem",
                height: "100%",
                width: "100%",
                paddingRight: "1rem",
                paddingTop: "1rem",
              }}
            >
              <div>
                <span
                  style={{
                    fontSize: "0.8rem",
                    color: "gray",
                    letterSpacing: "0.5px",
                  }}
                >
                  PT#19203459
                </span>
                <h4 style={{ fontWeight: "700", margin: "0.4rem 0" }}>
                  Harry Mate
                </h4>
              </div>

              <div style={{ paddingTop: "1rem" }}>
                <div
                  style={{
                    marginTop: "3rem",
                    marginBottom: "1.5rem",
                    borderBottom: "1px solid gray",
                  }}
                >
                  <h5
                    style={{
                      letterSpacing: "0.5px",
                      fontWeight: "600",
                      marginBottom: "0.5rem",
                      fontSize: "0.95rem",
                      color: "#2b2b2b",
                    }}
                  >
                    {" "}
                    Patient Details
                  </h5>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  {/* Email */}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="iconStyle">
                      <CiMail size={18} />
                    </div>
                    <div>
                      <div className="labelStyle">Email Address</div>
                      <div className="valueStyle">brianrobbin@gmail.com</div>
                    </div>
                  </div>

                  {/* Phone */}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="iconStyle">
                      <IoCallOutline size={18} />
                    </div>
                    <div>
                      <div className="labelStyle">Phone</div>
                      <div className="valueStyle">(831) 522-5847</div>
                    </div>
                  </div>

                  {/* Source */}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="iconStyle">
                      <MdOutlineBloodtype size={18} />
                    </div>
                    <div>
                      <div className="labelStyle">Blood</div>
                      <div className="valueStyle">AB+</div>
                    </div>
                  </div>

                  {/* age */}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="iconStyle">
                      <PiPersonArmsSpreadLight size={18} />
                    </div>
                    <div>
                      <div className="labelStyle">Age</div>
                      <div className="valueStyle">22</div>
                    </div>
                  </div>

                  {/* gender */}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="iconStyle">
                      <LuUsersRound size={18} />
                    </div>
                    <div>
                      <div className="labelStyle">Gender</div>
                      <div className="valueStyle">Male</div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ paddingTop: "1rem" }}>
                <div
                  style={{
                    marginTop: "3rem",
                    marginBottom: "1.5rem",
                    borderBottom: "1px solid gray",
                  }}
                >
                  <h5
                    style={{
                      letterSpacing: "0.5px",
                      fontWeight: "600",
                      marginBottom: "0.5rem",
                      fontSize: "0.95rem",
                      color: "#2b2b2b",
                    }}
                  >
                    {" "}
                    Contact Details
                  </h5>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  {/* Email */}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="iconStyle">
                      <CiMail size={18} />
                    </div>
                    <div>
                      <div className="labelStyle">Email Address</div>
                      <div className="valueStyle">brianrobbin@gmail.com</div>
                    </div>
                  </div>

                  {/* Phone */}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="iconStyle">
                      <IoCallOutline size={18} />
                    </div>
                    <div>
                      <div className="labelStyle">Phone</div>
                      <div className="valueStyle">(831) 522-5847</div>
                    </div>
                  </div>

                  {/* Source */}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="iconStyle">
                      <MdOutlineBloodtype size={18} />
                    </div>
                    <div>
                      <div className="labelStyle">Blood</div>
                      <div className="valueStyle">AB+</div>
                    </div>
                  </div>

                  {/* age */}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="iconStyle">
                      <PiPersonArmsSpreadLight size={18} />
                    </div>
                    <div>
                      <div className="labelStyle">Age</div>
                      <div className="valueStyle">22</div>
                    </div>
                  </div>

                  {/* gender */}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="iconStyle">
                      <LuUsersRound size={18} />
                    </div>
                    <div>
                      <div className="labelStyle">Gender</div>
                      <div className="valueStyle">Male</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ flex: 1, paddingLeft: "1rem" }}>
              {/* More content here */}

             <div style={{"borderBottom":"1px solid #ddd", paddingTop: "1.5REM"}}>
               <Stepper
                currentStep={3}
                pipeline="Patients Pipeline"
                stage="Proposal Sent"
                timer="Been this stage for 48 minutes"
                sequence="Proposals Sequence"
                drip="Follow up proposal"
                dripTime="Scheduled for Tomorrow 12:39 PM"
              />
             </div>

             <div>
{/* More tabs content here */}

<PatientTabs />
             </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default PatientDetails;
